import { Alert, type AlertProps } from '@mantine/core'
import { IconAlertTriangle } from '@tabler/icons-react'
import type { ReactNode } from 'react'

export interface AttentionBannerProps extends Omit<
    AlertProps,
    'color' | 'variant' | 'icon' | 'title' | 'style'
> {
    title: ReactNode
    // Defaults to the warning triangle; override only for a meaningfully
    // different cue (e.g. a settings glyph for "finish setup").
    icon?: ReactNode
}

// The shared warning notice. A warning-tinted Mantine Alert with a consistent
// icon + title, used for every "needs attention / heads up" message — the
// page-level banners at the top of the main pages AND in-context warnings inside
// modals and forms. Forwards Alert layout props (e.g. `mt`). For errors or info
// use a plain Alert with the matching semantic color, not this.
export function AttentionBanner({
    title,
    icon,
    children,
    ...others
}: AttentionBannerProps) {
    return (
        <Alert
            {...others}
            color='warning'
            variant='light'
            icon={icon ?? <IconAlertTriangle size={18} />}
            title={title}
            style={{ flexShrink: 0 }}
        >
            {children}
        </Alert>
    )
}
